import { render } from "./index.vue?vue&type=template&id=a94aec3c&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a94aec3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a94aec3c"]])

export default __exports__